@if(hasOptions) {
<ng-content select="[app-autocomplete-option-group-title]"></ng-content>
<div
  role="group"
  class="mb-2">
  <ng-container [ngTemplateOutlet]="optionsTpl"></ng-container>
</div>
}

<!-- Options Template -->
<ng-template #optionsTpl>
  <ng-content select="[app-autocomplete-option]"></ng-content>
</ng-template>
